// Stable per connection: filtering or sorting tickets never changes its color.
const palette = ["#047857", "#1D4ED8", "#7E22CE", "#BE123C", "#B45309", "#0E7490", "#4338CA", "#A21CAF", "#3F6212", "#9F1239", "#155E75", "#6D28D9"];
export function connectionColor(id) {
  if (id === null || id === undefined || id === "") return "#52525B";
  const number = Number(id);
  if (Number.isSafeInteger(number) && number > 0) return palette[(number - 1) % palette.length];
  let hash = 0;
  for (const char of String(id)) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return palette[hash % palette.length];
}
